import { Fragment } from "react";
import { champPath } from "../misc/Static";
import Champ from "../images/Champ";
import Elo from "../misc/Elo";
import Item from "../images/Item";
import Augment from "../images/Augment";
import { Link } from "react-router-dom";
import styles from "./MatchArenaRowTiny.module.css";

export const MatchArenaRowTiny = ({ match, calc, region, p, width }) => {
  return (
    <>
      <div className={styles.wrapper}>
        <div>
          <div className={styles.row1}>
            <div className={styles.champ}>
              <a
                href={
                  "https://lolalytics.com/lol/" +
                  champPath(match.champion[p]) +
                  "/build/"
                }
              >
                <Champ type="champ50b" id={match.champion[p]} />
              </a>
              <div>{match.champLevel[p]}</div>
            </div>
            <div className={styles.augment}>
              <div>
                {[0, 1].map((x) => (
                  <div key={x}>
                    {[0, 1].map((y) => (
                      <div key={y}>
                        <Augment
                          augment={match[`augment${x * 2 + y + 1}`][p]}
                          size="24"
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>

            <div className={styles.summoner}>
              <Link to={match.pathName[p]}>
                <div className={styles.name}>{match.summonerName[p]}</div>
              </Link>
            </div>
            <div className={styles.kda}>
              <span>{match.kills[p]}</span> / <span>{match.deaths[p]}</span> /{" "}
              <span>{match.assists[p]}</span>
            </div>
          </div>
          <div className={styles.row2}>
            <div className={styles.augment}>
              <Elo
                tier={match.tier[p].toLowerCase()}
                division={match.division[p]}
              />
            </div>
            <div className={styles.items}>
              <div>
                {match.items[p].map((item, i) => (
                  <Fragment key={"item" + i}>
                    {item === 0 && <div className={styles.placeholder}></div>}
                    {item > 0 && <Item type="item24r" id={item} />}
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default MatchArenaRowTiny;
